"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserRouter = exports.Route = exports.matchPath = exports.withRouter = exports.StaticRouter = exports.MemoryRouter = exports.Router = exports.Switch = exports.Redirect = exports.HashRouter = exports.NavLink = exports.Link = undefined;

var _reactRouterDom = require("react-router-dom");

Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Link;
  }
});
Object.defineProperty(exports, "NavLink", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.NavLink;
  }
});
Object.defineProperty(exports, "HashRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.HashRouter;
  }
});
Object.defineProperty(exports, "Redirect", {
  enumerable: true,
  get: function get() {
    return _reactRouterDom.Redirect;
  }
});

var _reactRouter = require("react-router");

Object.defineProperty(exports, "Switch", {
  enumerable: true,
  get: function get() {
    return _reactRouter.Switch;
  }
});
Object.defineProperty(exports, "Router", {
  enumerable: true,
  get: function get() {
    return _reactRouter.Router;
  }
});
Object.defineProperty(exports, "MemoryRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouter.MemoryRouter;
  }
});
Object.defineProperty(exports, "StaticRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouter.StaticRouter;
  }
});
Object.defineProperty(exports, "withRouter", {
  enumerable: true,
  get: function get() {
    return _reactRouter.withRouter;
  }
});
Object.defineProperty(exports, "matchPath", {
  enumerable: true,
  get: function get() {
    return _reactRouter.matchPath;
  }
});

var _AdvancedRoute = require("./AdvancedRoute");

var _AdvancedRoute2 = _interopRequireDefault(_AdvancedRoute);

var _BrowserRouter = require("./BrowserRouter");

var _BrowserRouter2 = _interopRequireDefault(_BrowserRouter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Route = exports.Route = _AdvancedRoute2.default;
var BrowserRouter = exports.BrowserRouter = _BrowserRouter2.default;